import * as db from '../../db'
// import _ from 'lodash'

export const LOADING_STEPPER = 'LOADING_STEPPER'
export const GET_STEPPERS = 'GET_STEPPERS'
export const SELECT_STEPPER = 'SELECT_STEPPER'

// Init State Object
const state = {
  loading: false,
  steppers: {},
  step: 0
}

// Getters
const getters = {
  steppers: state => state.steppers,
  loading: state => state.loading
}

// Actions
const actions = {
  getSteppers({ commit }) {
    commit(LOADING_STEPPER, true)
    db.steppers.onSnapshot(function(snapshot) {
      let steppers = {}
      snapshot.forEach(doc => {
        let stepper = doc.data()
        stepper.id = doc.id
        steppers[stepper.id] = stepper
      })
      commit(GET_STEPPERS, { steppers })
    })
    commit(LOADING_STEPPER, false)
  }
}

// Mutations (Setters)
const mutations = {
  [LOADING_STEPPER] (state, value) {
    state.loading = value
  },

  [GET_STEPPERS] (state, {steppers}) {
    state.steppers = steppers
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/stepper.js